import { toast } from 'react-toastify';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { ApiResponse } from 'api/ApiClient';
import { SuccessToastContainer } from 'components/Toast/ToastContainer';
import { IAction, ICardDetails, ITokenizeCardRequest } from 'types';
import { formatErrorMessages } from 'utils/errors';
import * as API from '../../api';
import * as Actions from './actions';
import * as ActionTypes from './types';

export function* createTokenizedCard({ payload }: IAction<ActionTypes.Card, { body: ITokenizeCardRequest }>) {
  try {
    const { body } = payload;
    const response: ApiResponse<ICardDetails> = yield call(API.Cards.tokenizeCard, body);
    yield put(Actions.createTokenizedCardSuccess(response.body));
  } catch (error: any) {
    const formattedError = formatErrorMessages({ errors: error.body?.errors, statusCode: error.statusCode });
    yield put(Actions.createTokenizedCardFail(formattedError));
  }
}

export function* getCard({ payload }: IAction<ActionTypes.Card, { cardId: string }>) {
  try {
    const { cardId } = payload;
    const response: ApiResponse<ICardDetails> = yield call(API.Cards.getCard, cardId);
    yield put(Actions.getCardSuccess(response.body));
  } catch (error: any) {
    yield put(Actions.getCardFail(error));
  }
}

export function* deleteCard({ payload }: IAction<ActionTypes.Card, { cardId: string }>) {
  try {
    const { cardId } = payload;
    const response: ApiResponse<ICardDetails> = yield call(API.Cards.deleteCard, cardId);

    yield put(Actions.deleteCardSuccess(response.body));
    yield call(toast, SuccessToastContainer({ message: 'Card successfully deleted' }));
  } catch (error: any) {
    yield put(Actions.deleteCardFail(error));
  }
}

export function* watchCreateTokenizedCard() {
  yield takeEvery(ActionTypes.Card.CREATE_TOKENIZED_CARD_REQUEST, createTokenizedCard);
}

export function* watchGetCard() {
  yield takeEvery(ActionTypes.Card.GET_CARD_REQUEST, getCard);
}

export function* watchDeleteCard() {
  yield takeEvery(ActionTypes.Card.DELETE_CARD_REQUEST, deleteCard);
}

function* cardSaga() {
  yield all([fork(watchCreateTokenizedCard), fork(watchGetCard), fork(watchDeleteCard)]);
}
export { cardSaga };
